import { useQuery } from '@tanstack/react-query';
import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';
import { Location } from 'src/models/location/_types';
import { fetchLocations } from 'src/models/location/location';

interface LocationFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
  multiple?: boolean;
}

export const LocationFilter: React.FC<LocationFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
  multiple,
}) => {
  const { data: locations = { locations: [] } } = useQuery({
    queryKey: ['locations'],
    queryFn: () => fetchLocations({ fetchAll: true }),
  });

  const locationIds = value ? String(value).split(',') : [];

  let selectedLocation = undefined as Location | undefined;
  let selectedLocations = [] as Location[];

  if (multiple) {
    selectedLocations = locations.locations.filter((l) =>
      locationIds?.includes(String(l.id))
    );
  } else {
    selectedLocation = locations.locations.find((l) => l.id === value);
  }

  if (valueOnly) {
    if (multiple) {
      return <>{selectedLocations?.map((l) => l.name)?.join(', ')}</>;
    }
    return <>{selectedLocation?.name || ''}</>;
  }

  return (
    <Autocomplete
      multiple={multiple}
      options={locations.locations}
      getOptionLabel={(option: Location) => option.name}
      value={multiple ? selectedLocations : selectedLocation || null}
      onChange={(_, newValue) => {
        if (multiple) {
          setValue(
            (Array.isArray(newValue) ? newValue : []).map((l) => l.id).join(',')
          );
        } else {
          setValue(String(newValue?.id || ''));
        }
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Location" />
      )}
    />
  );
};
